import React from 'react';

// Z-Index Hierarchy:
// - PIXI Canvas: 0 (background)
// - BetBox/ScoreBoard: 1000-1500 (UI components)
// - HUD: 2000 (top layer)

export const layoutStyles = (
  isLandscape: boolean
): Record<string, React.CSSProperties> => ({
  mainLayout: {
    // display: 'flex',
    // flexDirection: 'row',
    // height:'100vh',
    position: 'fixed',
    inset: 0,
    color: 'var(--brand-white)',
    pointerEvents: 'auto',
    background: 'transparent',
    overflow: 'hidden',
  },
  mainLayoutDesktop: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    position: 'fixed',
    inset: 0,
    color: 'var(--brand-white)',
    pointerEvents: 'none',
    background: 'transparent',
    overflow: 'hidden',
  },

  mainLayoutMobile: {
    width: '100%',
    height: 'auto !important',
    display: 'flex',
    flexDirection: 'row',
    // height: "100%",
    // position: "relative",
    inset: 0,
    color: 'var(--brand-white)',
    pointerEvents: 'none',
    background: 'transparent',
    overflow: 'hidden',
  },
  mainContentArea: {
    position: 'absolute',
    top: '40vh',
    left: '12vw',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  mainContentAreaMobile: {
    position: 'absolute',
    top: '110px',
    bottom: '140px',
    left: 0,
    right: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  mainContentAreaTablet: {
    position: 'absolute',
    top: '10px',
    bottom: '34vh',
    left: 0,
    right: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },

  multiplierText: {
    fontSize: '40px',
    fontWeight: 800,
    margin: 0,
    textShadow: '0 0 30px rgba(0,0,0,0.8)',
    fontFamily: "'Montserrat', sans-serif",
    letterSpacing: '-2px',
    userSelect: 'none',
  },
  flewAwayText: {
    fontSize: '42px',
    fontWeight: 500,
    color: 'rgba(255,255,255,0.8)',
    display: 'block',
    marginBottom: '-10px',
    userSelect: 'none',
  },
  waitingText: {
    fontSize: '32px',
    color: 'rgba(255,255,255,0.7)',
    fontWeight: 600,
    fontFamily: "'Montserrat', sans-serif",
  },
  betControlsDesktop: {
    position: 'fixed',
    bottom: '1vh',
    left: '27.2vw',
    right: '0.3vw',
    height: 'clamp(122px, 25.15vh, 192px)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    zIndex: 1000,
    gap: '0.267vw',
    color: '#000000',
  },
  betControlsTablet: {
    position: 'fixed',
    bottom: isLandscape ? '6vh' : '34vh',
    left: '0.75vw',
    right: '0.75vw',
    height: isLandscape
      ? 'clamp(143px, 24vh, 200px)'
      : 'clamp(120px, 24vh, 400px)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    zIndex: 1000,
    gap: '0.5vw',
    color: '#000000',
  },
  betControlsMobile: {
    width: '100%',
    position: 'fixed',
    top: '44vh',
    // bottom: "28vh", //"210px",
    left: '0px',
    right: '0px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    zIndex: 1000,
    gap: '10px',
    color: '#000000',
    // Ensure smooth transitions for swipe gestures
    transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out',
  },
  controlsContainer: {
    position: 'absolute',
    bottom: '20px',
    right: '20px',
    display: 'flex',
    gap: '8px',
    pointerEvents: 'auto',
  },
  controlBtn: {
    padding: '8px 16px',
    background: 'rgba(0,0,0,0.7)',
    border: '1px solid #333',
    borderRadius: '6px',
    color: 'white',
    cursor: 'pointer',
    fontSize: '12px',
  },
  activePlayersContainer: {
    position: 'absolute',
    bottom: '230px',
    right: '40px',
    zIndex: 150,
    pointerEvents: 'auto',
  },
  controls: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    gap: '3px',
  },
});
